module.exports = __webpack_public_path__ + "media/images/logout-bf57f609f46d7840b5ede48fb5669dda.png";